export let Theme = /*#__PURE__*/function (Theme) {
  Theme["LightMode"] = "LightMode";
  Theme["DarkMode"] = "DarkMode";
  return Theme;
}({});